// wait for an element to become available in the DOM
// borrowed from https://stackoverflow.com/questions/5525071/how-to-wait-until-an-element-exists#answer-61511955
export function waitForElement(selector) : Promise<any> {

    return new Promise(resolve => {

        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}